import React from "react";

export default function Loader() {
  return (
    <div className="fixed top-0 left-0 z-50 w-full h-full flex items-center justify-center">
      <div className="w-16 h-16 border-8 border-dashed rounded-full animate-spin border-[#88087B]"></div>
    </div>
  );
}
